import "react-datepicker/dist/react-datepicker.css"

import "./DateRangePicker.css"

import { useCallback } from "react"
import DatePicker, { ReactDatePickerProps } from "react-datepicker"

export type DateRangeType = [Date | null, Date | null]

interface DateRangePickerProps extends ReactDatePickerProps<never, true> {}

export function DateRangePicker({ startDate, endDate, onChange, ...props }: DateRangePickerProps) {
    const handleOnChange = useCallback(
        (dateRange: DateRangeType, event: React.SyntheticEvent) => {
            onChange(dateRange, event)
        },
        [onChange],
    )

    // NOTE: if we don't provide attribute selected, we will lose time information
    // ex: Tue Apr 19 2022 00:00:00 GMT+0800 (台北標準時間) -> time part is always 00:00:00
    // if we provide selected, we can get Tue Apr 19 2022 16:19:09 GMT+0800 (台北標準時間)
    return (
        <DatePicker
            selected={startDate}
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={handleOnChange}
            {...props}
        />
    )
}
